function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#keyboard-shortcut_svg__filter0_d)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#keyboard-shortcut_svg__filter1_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 112,
  y: 116,
  width: 96,
  height: 88,
  rx: 8,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("path", {
  d: "M156.516 172.438v-13.985h-2.078V181h2.078v-6.297l1.812-1.672 6.5 7.969h2.422l-7.438-9.234 7.297-7.016h-2.562l-8.031 7.688z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.768 134.902l1.502-4.475h-1.619l-.921 4.475h1.038z",
  fill: "#B6B6B6"
}));

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 448,
  y: 116,
  width: 96,
  height: 88,
  rx: 8,
  fill: "#fff",
  opacity: 0.1
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 448,
  width: 96,
  height: 100,
  rx: 8,
  fill: "url(#keyboard-shortcut_svg__paint0_linear)",
  opacity: 0.1
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  y: 116,
  width: 96,
  height: 88,
  rx: 8,
  fill: "#fff",
  opacity: 0.1
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  width: 96,
  height: 100,
  rx: 8,
  fill: "url(#keyboard-shortcut_svg__paint1_linear)",
  opacity: 0.1
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 112,
  width: 96,
  height: 100,
  rx: 8,
  fill: "url(#keyboard-shortcut_svg__paint2_linear)",
  opacity: 0.1
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 224,
  width: 96,
  height: 100,
  rx: 8,
  fill: "url(#keyboard-shortcut_svg__paint3_linear)",
  opacity: 0.1
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 336,
  width: 96,
  height: 100,
  rx: 8,
  fill: "url(#keyboard-shortcut_svg__paint4_linear)",
  opacity: 0.1
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#keyboard-shortcut_svg__filter2_d)"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#keyboard-shortcut_svg__filter3_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 224,
  y: 116,
  width: 208,
  height: 88,
  rx: 8,
  fill: "#D1D5DB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 224,
  y: 116,
  width: 208,
  height: 88,
  rx: 8,
  fill: "#A9B0BC",
  fillOpacity: 0.9
})), /*#__PURE__*/React.createElement("path", {
  d: "M247.095 178.41c.181 2.371 2.19 3.914 5.103 3.914 3.143 0 5.133-1.609 5.133-4.133 0-2.018-1.143-3.123-3.99-3.837l-1.438-.381c-1.894-.485-2.647-1.104-2.647-2.18 0-1.39 1.21-2.304 3.038-2.304 1.714 0 2.875.838 3.113 2.247h1.724c-.143-2.219-2.124-3.799-4.78-3.799-2.904 0-4.856 1.58-4.856 3.913 0 1.952 1.076 3.076 3.561 3.704l1.761.457c1.895.476 2.752 1.219 2.752 2.39 0 1.361-1.361 2.361-3.209 2.361-1.952 0-3.323-.914-3.532-2.352h-1.733zm16.377-5.408c1.628 0 2.713 1.2 2.751 3.019h-5.655c.124-1.819 1.266-3.019 2.904-3.019zm2.704 6.342c-.429.904-1.324 1.39-2.647 1.39-1.743 0-2.876-1.286-2.961-3.314v-.076h7.379v-.628c0-3.19-1.685-5.161-4.456-5.161-2.819 0-4.628 2.095-4.628 5.322 0 3.247 1.781 5.304 4.628 5.304 2.247 0 3.846-1.086 4.323-2.837h-1.638zm4.427-10.265v2.657h-1.657v1.371h1.657v6.227c0 1.961.848 2.742 2.961 2.742.324 0 .638-.038.962-.095V180.6a6.809 6.809 0 01-.762.038c-1.066 0-1.523-.514-1.523-1.723v-5.808h2.285v-1.371h-2.285v-2.657h-1.638zm10.255 9.331c.18 2.371 2.19 3.914 5.103 3.914 3.142 0 5.132-1.609 5.132-4.133 0-2.018-1.142-3.123-3.989-3.837l-1.438-.381c-1.895-.485-2.647-1.104-2.647-2.18 0-1.39 1.209-2.304 3.037-2.304 1.714 0 2.876.838 3.114 2.247h1.723c-.143-2.219-2.123-3.799-4.78-3.799-2.904 0-4.856 1.58-4.856 3.913 0 1.952 1.076 3.076 3.562 3.704l1.761.457c1.895.476 2.752 1.219 2.752 2.39 0 1.361-1.362 2.361-3.209 2.361-1.952 0-3.323-.914-3.533-2.352h-1.732zm12.377 3.59h1.638v-6.075c0-1.733 1.009-2.894 2.847-2.894 1.552 0 2.371.904 2.371 2.723V182h1.638v-6.646c0-2.409-1.372-3.799-3.542-3.799-1.572 0-2.647.666-3.162 1.799h-.152v-5.693h-1.638V182zm15.101.181c2.923 0 4.732-2.019 4.732-5.313 0-3.304-1.809-5.313-4.732-5.313s-4.732 2.009-4.732 5.313c0 3.294 1.809 5.313 4.732 5.313zm0-1.476c-1.942 0-3.037-1.409-3.037-3.837 0-2.438 1.095-3.837 3.037-3.837 1.943 0 3.038 1.399 3.038 3.837 0 2.428-1.095 3.837-3.038 3.837zm6.703 1.295h1.638v-6.36c0-1.448 1.133-2.495 2.695-2.495.323 0 .914.057 1.047.095v-1.637a6.938 6.938 0 00-.819-.048c-1.362 0-2.542.705-2.847 1.704h-.152v-1.523h-1.562V182zm8.084-12.921v2.657h-1.657v1.371h1.657v6.227c0 1.961.847 2.742 2.961 2.742.324 0 .638-.038.962-.095V180.6a6.82 6.82 0 01-.762.038c-1.066 0-1.523-.514-1.523-1.723v-5.808h2.285v-1.371h-2.285v-2.657h-1.638zm14.139 5.799c-.286-1.828-1.809-3.323-4.304-3.323-2.875 0-4.703 2.076-4.703 5.275 0 3.266 1.837 5.351 4.713 5.351 2.466 0 3.999-1.39 4.294-3.275h-1.657c-.304 1.161-1.266 1.799-2.647 1.799-1.828 0-3.008-1.504-3.008-3.875 0-2.323 1.161-3.799 3.008-3.799 1.476 0 2.381.828 2.647 1.847h1.657zm10.121-3.142h-1.637v6.075c0 1.799-.991 2.875-2.8 2.875-1.637 0-2.323-.857-2.323-2.704v-6.246h-1.638v6.646c0 2.428 1.2 3.799 3.504 3.799 1.571 0 2.666-.648 3.18-1.79h.153V182h1.561v-10.264zm3.171-2.657v2.657h-1.657v1.371h1.657v6.227c0 1.961.847 2.742 2.961 2.742.324 0 .638-.038.962-.095V180.6a6.82 6.82 0 01-.762.038c-1.066 0-1.523-.514-1.523-1.723v-5.808h2.285v-1.371h-2.285v-2.657h-1.638z",
  fill: "#000"
}));

var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "keyboard-shortcut_svg__paint0_linear",
  x1: 496,
  y1: 0,
  x2: 496,
  y2: 100,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "keyboard-shortcut_svg__paint1_linear",
  x1: 48,
  y1: 0,
  x2: 48,
  y2: 100,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "keyboard-shortcut_svg__paint2_linear",
  x1: 160,
  y1: 0,
  x2: 160,
  y2: 100,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "keyboard-shortcut_svg__paint3_linear",
  x1: 272,
  y1: 0,
  x2: 272,
  y2: 100,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "keyboard-shortcut_svg__paint4_linear",
  x1: 384,
  y1: 0,
  x2: 384,
  y2: 100,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("filter", {
  id: "keyboard-shortcut_svg__filter0_d",
  x: 98,
  y: 102,
  width: 132,
  height: 124,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 4,
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "keyboard-shortcut_svg__filter1_d",
  x: 112,
  y: 116,
  width: 96,
  height: 89,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "keyboard-shortcut_svg__filter2_d",
  x: 210,
  y: 102,
  width: 244,
  height: 125,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 4,
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "keyboard-shortcut_svg__filter3_d",
  x: 224,
  y: 116,
  width: 208,
  height: 89,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

function SvgKeyboardShortcut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 544,
    height: 226,
    viewBox: "0 0 544 226",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

export default "data:image/svg+xml;base64,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";
export { SvgKeyboardShortcut as ReactComponent };